(function () {

  function initLS8MegaMenus(root) {

    const scope = root || document;

    scope
      .querySelectorAll('[data-ls8-mega-menu]')
      .forEach(function (menu) {

        /*
          防止 Shopify 编辑器重复初始化
        */
        if (menu.dataset.ls8Initialized === 'true') {
          return;
        }

        menu.dataset.ls8Initialized = 'true';


        const parent =
          menu.closest('.ls8-mega-parent');


        const categories =
          menu.querySelectorAll('[data-ls8-category]');


        const seriesPanels =
          menu.querySelectorAll('[data-ls8-series-panel]');


        const seriesItems =
          menu.querySelectorAll('[data-ls8-series]');


        const productPanels =
          menu.querySelectorAll('[data-ls8-product-panel]');


        const hotCategory =
          menu.querySelector('[data-ls8-hot-category]');


        const hotProductPanel =
          menu.querySelector('[data-ls8-hot-product-panel]');


        let closeTimer = null;



        /* =====================================================
           OPEN / CLOSE
        ====================================================== */

        function openMenu() {

          if (closeTimer) {
            clearTimeout(closeTimer);
            closeTimer = null;
          }

          if (parent) {
            parent.classList.add('is-open');
          }

        }


        function closeMenuLater() {

          if (closeTimer) {
            clearTimeout(closeTimer);
          }

          closeTimer = setTimeout(function () {

            if (parent) {
              parent.classList.remove('is-open');
            }

          }, 300);

        }


        if (parent) {

          parent.addEventListener(
            'mouseenter',
            openMenu
          );


          parent.addEventListener(
            'mouseleave',
            closeMenuLater
          );

        }


        menu.addEventListener(
          'mouseenter',
          openMenu
        );


        menu.addEventListener(
          'mouseleave',
          closeMenuLater
        );



        /* =====================================================
           RESET HELPERS
        ====================================================== */

        function clearCategories() {

          categories.forEach(function (item) {
            item.classList.remove('is-active');
          });


          if (hotCategory) {
            hotCategory.classList.remove('is-active');
          }

        }


        function clearSeriesPanels() {

          seriesPanels.forEach(function (panel) {
            panel.classList.remove('is-active');
          });

        }


        function clearSeriesItems() {

          seriesItems.forEach(function (item) {
            item.classList.remove('is-active');
          });

        }


        function clearProductPanels() {

          productPanels.forEach(function (panel) {
            panel.classList.remove('is-active');
          });


          if (hotProductPanel) {
            hotProductPanel.classList.remove('is-active');
          }

        }



        /* =====================================================
           HOT MODE
        ====================================================== */

        function activateHot() {

          clearCategories();
          clearSeriesPanels();
          clearSeriesItems();
          clearProductPanels();


          /*
            只有 HOT 激活时才进入两栏布局
          */
          menu.classList.add('is-hot-active');


          if (hotCategory) {
            hotCategory.classList.add('is-active');
          }


          if (hotProductPanel) {
            hotProductPanel.classList.add('is-active');
          }

        }



        if (hotCategory) {

          hotCategory.addEventListener(
            'mouseenter',
            activateHot
          );


          hotCategory.addEventListener(
            'focus',
            activateHot
          );


          hotCategory.addEventListener(
            'click',
            activateHot
          );

        }



        /* =====================================================
           NORMAL CATEGORY
           STANDARD / COLOR / SPECIALTY
        ====================================================== */

        function activateCategory(target) {

          /*
            第一件事：
            强制退出 HOT 两栏状态
          */
          menu.classList.remove('is-hot-active');


          clearCategories();
          clearSeriesPanels();
          clearSeriesItems();
          clearProductPanels();


          const category =
            menu.querySelector(
              '[data-ls8-category="' +
              target +
              '"]'
            );


          const seriesPanel =
            menu.querySelector(
              '[data-ls8-series-panel="' +
              target +
              '"]'
            );


          if (category) {
            category.classList.add('is-active');
          }


          if (!seriesPanel) {
            return;
          }


          seriesPanel.classList.add('is-active');


          /*
            自动打开当前分类的第一个三级目录
          */
          const firstSeries =
            seriesPanel.querySelector(
              '[data-ls8-series]'
            );


          if (!firstSeries) {
            return;
          }


          firstSeries.classList.add('is-active');


          const firstTarget =
            firstSeries.getAttribute(
              'data-ls8-series'
            );


          const firstProductPanel =
            menu.querySelector(
              '[data-ls8-product-panel="' +
              firstTarget +
              '"]'
            );


          if (firstProductPanel) {
            firstProductPanel.classList.add('is-active');
          }

        }



        categories.forEach(function (category) {

          function changeCategory() {

            const target =
              this.getAttribute(
                'data-ls8-category'
              );


            if (target) {
              activateCategory(target);
            }

          }


          category.addEventListener(
            'mouseenter',
            changeCategory
          );


          category.addEventListener(
            'focus',
            changeCategory
          );


          category.addEventListener(
            'click',
            changeCategory
          );

        });



        /* =====================================================
           THIRD LEVEL SERIES
        ====================================================== */

        function activateSeries(target) {

          /*
            三级目录一定属于普通模式
          */
          menu.classList.remove('is-hot-active');


          clearSeriesItems();
          clearProductPanels();


          const seriesItem =
            menu.querySelector(
              '[data-ls8-series="' +
              target +
              '"]'
            );


          const productPanel =
            menu.querySelector(
              '[data-ls8-product-panel="' +
              target +
              '"]'
            );


          if (seriesItem) {
            seriesItem.classList.add('is-active');
          }


          if (productPanel) {
            productPanel.classList.add('is-active');
          }

        }



        seriesItems.forEach(function (item) {

          function changeSeries() {

            const target =
              this.getAttribute(
                'data-ls8-series'
              );


            if (target) {
              activateSeries(target);
            }

          }


          item.addEventListener(
            'mouseenter',
            changeSeries
          );


          item.addEventListener(
            'focus',
            changeSeries
          );


          item.addEventListener(
            'click',
            changeSeries
          );

        });



        /* =====================================================
           INITIAL STATE
        ====================================================== */

        if (hotCategory && hotProductPanel) {

          activateHot();

        }

        else {

          const firstCategory =
            categories[0];


          if (firstCategory) {

            const firstTarget =
              firstCategory.getAttribute(
                'data-ls8-category'
              );


            if (firstTarget) {
              activateCategory(firstTarget);
            }

          }

        }

      });

  }



  /* =========================================================
     NORMAL PAGE LOAD
     ========================================================= */

  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      function () {
        initLS8MegaMenus(document);
      }
    );

  }

  else {

    initLS8MegaMenus(document);

  }



  /* =========================================================
     SHOPIFY THEME EDITOR
     Header / Section reload
     ========================================================= */

  document.addEventListener(
    'shopify:section:load',
    function (event) {

      initLS8MegaMenus(event.target);

    }
  );



  document.addEventListener(
    'shopify:section:select',
    function (event) {

      initLS8MegaMenus(event.target);

    }
  );

})();